export const userTypes = {
  employer: 'employer',
  agency: 'agency',
  worker: 'worker',
}
